import { Component, OnInit } from '@angular/core';

/**
 * Página de roles para administrar la asignación de roles a usuarios de Asambleas
 * Aclaración: Esta página no crea roles o modifica roles existentas en la plataforma
 */
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/roles/roles.component.ts